import {TaxSummary as TaxSummaryV1} from '@wix/auto_sdk_ecom_current-cart';
import {V2TaxSummary as TaxSummary} from '@wix/auto_sdk_ecom_cart-v-2';

export class TaxSummaryModel {
  public taxName?: string;

  constructor(params: TaxSummaryModel) {
    this.taxName = params.taxName;
  }

  public static fromCartV1(taxSummary?: TaxSummaryV1) {
    return new TaxSummaryModel({
      taxName: taxSummary?.taxName ?? '',
    });
  }

  public static fromCartV2(_taxSummary: TaxSummary): TaxSummaryModel {
    return new TaxSummaryModel({
      taxName: '',
    });
  }
}
